import React from "react";
import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Doughnut } from "react-chartjs-2";

import ProcesosApi from "api/procesosApi";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";

const BarChartProcesosEtapa = () => {
  const [datosProcesosEtapa, setDatosProcesosEtapa] = useState({ labels: [], values: [] });

  useEffect(() => {
    const fetchDatosProcesosFinalidad = async () => {
      try {
        const respProcesosFinalidad = await ProcesosApi.obtenerEstadisticas("PROCESOS_POR_ETAPA");
        const data = respProcesosFinalidad.data;
        //alert(JSON.stringify(data));
        const labels = data.map((item) => item.etapa);
        const values = data.map((item) => item.cantidad);
        setDatosProcesosEtapa({ labels, values });
      } catch (error) {
        console.error("Error al obtener los datos del backend:", error);
      }
    };
    fetchDatosProcesosFinalidad();
  }, []);

  const colors = [
    "#FFB6C1",
    "#87CEFA",
    "#FFD700",
    "#32CD32",
    "#FFA07A",
    "#9370DB",
    "#40E0D0",
    "#FF6347",
    "#4682B4",
    "#A52A2A",
  ];

  const chartRef = useRef();
  const onClick = (event) => {
    //console.log(getDatasetAtEvent(chartRef.current, event));
    console.log(chartRef.current);
    console.log(event);
  };

  const chartData = {
    labels: datosProcesosEtapa.labels,
    datasets: [
      {
        data: datosProcesosEtapa.values,
        backgroundColor: colors.slice(0, datosProcesosEtapa.labels.length), // Usar colores según la cantidad de finalidades
        borderColor: colors.slice(0, datosProcesosEtapa.labels.length).map((color) => `${color}99`), // Color de borde más claro
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: true, // Activa el título
        text: "Procesos por Etapa", // Título del gráfico
        font: {
          size: 20, // Tamaño de la fuente del título
          weight: "bold", // Negrita
        },
        color: "dark", // Color del texto del título
      },
      tooltip: {
        enabled: true,
        callbacks: {
          // Personaliza el contenido del tooltip
          title: () => "", // Desactiva el título del tooltip
          label: function (context) {
            const label = context.label || ""; // Estado
            const value = context.raw || 0; // Número de procesos
            const procesoText = value === 1 ? "proceso" : "procesos";
            return `${label}: ${value} ${procesoText}`;
          },
        },
      },
    },
  };

  return (
    <SuiBox
      backgroundColor="#FFFFFF"
      borderRadius="lg"
      py={2}
      pr={0.5}
      mb={3}
      height="15rem"
      backgroundGradient
    >
      <Doughnut ref={chartRef} data={chartData} options={options} onClick={onClick} />
    </SuiBox>
  );
};

BarChartProcesosEtapa.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    values: PropTypes.arrayOf(PropTypes.number).isRequired,
  }).isRequired,
};

export default BarChartProcesosEtapa;
